
import React from 'react';
import { Helmet } from 'react-helmet-async';
import GameHero from '../components/capybara/GameHero';
import GameDescription from '../components/capybara/GameDescription';
import GameFAQ from '../components/capybara/GameFAQ';
import GameGuide from '../components/capybara/GameGuide';
import GameFeatures from '../components/capybara/GameFeatures';

const CapybaraClicker = () => {
  return (
    <>
      <Helmet>
        <title>Capybara Clicker 3D - Free Online Incremental Capybara Game</title>
        <meta 
          name="description" 
          content="Play Capybara Clicker 3D free online! Build your capybara empire, unlock upgrades, and customize your cute capybaras in this addictive incremental clicker game." 
        />
        <meta name="keywords" content="Capybara Clicker 3D, free online game, incremental game, capybara game, clicker game, 3D game" />
        <link rel="canonical" href="https://pokedle.com/capybara-clicker" />
      </Helmet>

      <div className="bg-gradient-to-b from-purple-900 via-purple-800 to-indigo-900 text-white min-h-screen">
        <GameHero />
        
        <div className="container mx-auto px-4 py-8">
          {/* Game iframe container */}
          <div className="my-10">
            <h2 className="text-3xl font-bold mb-6 text-center text-yellow-300 drop-shadow-lg">Play Capybara Clicker 3D</h2>
            <div className="game-wrapper bg-black rounded-xl shadow-2xl overflow-hidden border-4 border-yellow-400">
              <iframe 
                src="https://bitlifeonline.github.io/capybara-clicker-2/" 
                style={{ width: '100%', height: '100%' }} 
                frameBorder="0" 
                allow="gamepad *;"
                title="Capybara Clicker 3D Game"
              ></iframe>
            </div>
          </div>
          
          <GameDescription />
          <GameFeatures />
          <GameGuide />
          <GameFAQ />
        </div>
      </div>
    </>
  );
};

export default CapybaraClicker;
